import { c as _c } from "react/compiler-runtime";
import Button from '@precis-digital/kurama/Button';
import Grid from '@precis-digital/kurama/Grid';
import { styled } from '@precis-digital/kurama/utils';
import { useTranslation } from 'shared/translations';
interface FormButtonsProps {
  isSaveDisabled: boolean;
  onSave: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
const FormButtons = t0 => {
  const $ = _c(14);
  const {
    onSave,
    onCancel,
    isSaveDisabled
  } = t0;
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] !== t) {
    t1 = t("buttons.save");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isSaveDisabled || $[3] !== onSave || $[4] !== t1) {
    t2 = <Button onClick={onSave} variant="filled" disabled={isSaveDisabled}>{t1}</Button>;
    $[2] = isSaveDisabled;
    $[3] = onSave;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("buttons.cancel");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onCancel || $[9] !== t3) {
    t4 = <Button onClick={onCancel} variant="text">{t3}</Button>;
    $[8] = onCancel;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <StyledGrid display="flex" gap="8px">{t2}{t4}</StyledGrid>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default FormButtons;
const StyledGrid = styled(Grid)(() => ({
  '& button': {
    padding: '8px 16px'
  }
}));